import Dexie, { EntityTable, Table } from 'dexie'

import { AuditCampaign, ConditionReport, DataUpdateCacherStats, Expression, Item, Manifestation, Record, Work } from '@skinsoft/types'

export const CACHE_UP_DB_NAME = "cache-up"

export const dbCacheUp = new Dexie(CACHE_UP_DB_NAME) as Dexie & {
    auditCampaign: EntityTable<
        Partial<AuditCampaign>,
        'id'
    >,
    auditRecord: EntityTable<
        Partial<Record>,
        'id'
    >,
    conditionReport: EntityTable<
        Partial<ConditionReport>,
        'id'
    >,
    expression: EntityTable<
        Partial<Expression>,
        'id'
    >,
    item: EntityTable<
        Partial<Item>,
        'id'
    >,
    manifestation: EntityTable<
        Partial<Manifestation>,
        'id'
    >,
    media: Table<
        File | string,
        string
    >,
    syncUpStats: Table<
        DataUpdateCacherStats,
        string
    >,
    work: EntityTable<
        Partial<Work>,
        'id'
    >,
}

dbCacheUp.version(1).stores({
    auditCampaign: 'id',
    auditRecord: 'id',
    conditionReport: 'id',
    expression: 'id',
    item: 'id',
    manifestation: 'id',
    media: '',
    syncUpStats: '',
    work: 'id',
})